import React from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'
import { connect } from 'react-redux'

import PayrollRow from './PayrollRow'
import PayrollTableHeader from './PayrollTableHeader'
import ModulesUtils from '../../infra/ModulesUtils'

import moment from 'moment'

class PayrollTable extends React.Component {

  static propTypes = {
    teamId: PropTypes.string.isRequired,
    teamMembers: PropTypes.array.isRequired,
    workerId: PropTypes.string.isRequired,
    startDateStr: PropTypes.string.isRequired,
    endDateStr: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      timesheets: {},
      billables: {}
    }
  }

  componentWillMount(){
    this.initLoaders(this.props.workerId, this.props.startDateStr, this.props.endDateStr)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.workerId !== nextProps.workerId
      || this.props.startDateStr !== nextProps.startDateStr
      || this.props.endDateStr !== nextProps.endDateStr) {
      this.detachLoaders(this.props.workerId)
      this.initLoaders(nextProps.workerId, nextProps.startDateStr, nextProps.endDateStr)
    }
  }

  getTimesheetPath = (workerId) => {
    return `timesheets/${workerId}@${this.props.teamId}/`
  }

  getBillablePath = (workerId) => {
    return `bws/${workerId}@${this.props.teamId}/`
  }

  initLoaders(workerId, startDateStr, endDateStr) {
    firebase.database().ref(this.getTimesheetPath(workerId))
      .orderByKey()
      .startAt(startDateStr).endAt(endDateStr)
      .on('value', this.onTimesheetValue)
    firebase.database().ref(this.getBillablePath(workerId))
      .orderByKey()
      .startAt(startDateStr).endAt(endDateStr)
      .on('value', this.onBillableValue)
  }

  detachLoaders(workerId) {
    firebase.database().ref(this.getTimesheetPath(workerId))
      .off('value', this.onTimesheetValue)
    firebase.database().ref(this.getBillablePath(workerId))
      .off('value', this.onBillableValue)
  }

  onTimesheetValue = (snapshot) => {
    const value = snapshot.val() || {}
    this.setState({ timesheets: value })
  }

  onBillableValue = (snapshot) => {
    const value = snapshot.val() || {}
    this.setState({ billables: value })
  }

  getTimesheetModule = (dateStr, module) => {
    const dayTimesheet = this.state.timesheets[dateStr]
    // Checks for value present
    if (!dayTimesheet || !dayTimesheet.info || !dayTimesheet.info.modules
      || !dayTimesheet.info.modules[module]) {
      return {}
    }
    return dayTimesheet.info.modules[module]
  }

  getDayBillable = (dateStr) => {
    const dayBw = this.state.billables[dateStr]
    if (!dayBw || !dayBw.billable) {
      return 0
    }
    return dayBw.billable
  }

  renderRows() {
    const views = []
    let grayBackground = false
    let cursor = moment(this.props.startDateStr)
    const endDate = moment(this.props.endDateStr)
    while (cursor.isSameOrBefore(endDate)) {
      const backgroundColor = grayBackground ? '#fffcf7' : 'white'
      const dateStr = cursor.format('YYYY-MM-DD')
      views.push(
        <PayrollRow
          key={cursor.format()}
          dateStr={cursor.format()}
          backgroundColor={backgroundColor}
          workerId={this.props.workerId}
          dayClocking={this.getTimesheetModule(dateStr, 'clockingDay')}
          billable={this.getDayBillable(dateStr)}
          notes={this.getTimesheetModule(dateStr, 'notesEndDay')}
          signature={this.getTimesheetModule(dateStr, 'signature')}
          teamId={this.props.teamId} />
      )
      grayBackground = !grayBackground
      cursor = cursor.clone().add(1, 'days')
    }
    return views
  }

  render() {
    return (
      <div style={styles.container}>
        <span style={styles.name}>
          { ModulesUtils.getMemberName(this.props.teamMembers, this.props.workerId) }
        </span>
        <PayrollTableHeader />
        { this.renderRows() }
      </div>
    )
  }
  
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    marginBottom: 25
  },
  name: {
    fontSize: 18,
    color: '#527da3',
    fontWeight: '500'
  }
}

const mapStateToProps = state => ({
  teamId: state.firebase.team.metadata.value.id,
  teamMembers: state.firebase.team.members.value
})

export default connect(mapStateToProps)(PayrollTable)



// WEBPACK FOOTER //
// ./src/reports/payroll/PayrollTable.js